import MQTTSettings from './MQTTSettings'

export default MQTTSettings
